export default __webpack_public_path__ + "static/media/inner-logo.cf43ee3b.svg";